import { Multimedia } from '../../shared/models/multimedia';

export class AdminMultimediaImageGalleria {
  public constructor(
    private readonly data: {
      images: Multimedia[];
      activeIndex: number;
    },
  ) {}

  public get images(): Multimedia[] {
    return this.data.images;
  }

  public get activeIndex(): number {
    return this.data.activeIndex;
  }
}
